{
  "welcome": "Tervetuloa,",
  "welcome_back": "Tervetuloa takaisin,",
  "welcome_first": "Tervetuloa käyttämään Impactia!",
  "empty_subtitle": "Sinulla ei ole vielä kierroksia. Aloita seuranta ja katso kuinka pelisi kehittyy.",
  "start_round": "Aloita kierros",
  "browse_calendar": "Selaa kilpailukalenteria",
  "hcp": "HCP",
  "societyInvite": {
    "label": "Kutsu yhteisöön",
    "body": "on kutsunut sinut jäseneksi. Jäsenenä näet yhteisön tapahtumat ja voit ilmoittautua niihin.",
    "decline": "Hylkää",
    "accept": "Hyväksy"
  },
  "golfer": "Golfaaja",
  "your_rounds": "Viimeisimmät kierrokset",
  "no_rounds_yet": "Ei vielä kierroksia",
  "start_first_round_message": "Aloita ensimmäinen kierroksesi seurataksesi golf-tuloksiasi!",
  "start_your_first_round": "Aloita ensimmäinen kierroksesi",
  "latest_registrations": {
    "title": "Viimeisimmät rekisteröitymiset",
    "show_more": "Näytä lisää"
  },
  "latest_scorecards": {
    "title": "Viimeisimmät tuloskortit",
    "empty": "Ei tallennettuja tuloskortteja",
    "has_statistics": "Sisältää tilastoja",
    "types": {
      "competition": "Kilpailukierros",
      "handicap": "Tasoituskierros",
      "regular": "Harjoituskierros"
    }
  },
  "latest_payments": {
    "title": "Viimeisimmät maksut",
    "show_more": "Näytä lisää",
    "empty": "Ei maksuja"
  },
  "tabs": {
    "my_rounds": "Omat",
    "all": "Kaikki",
    "upcoming": "Tulevat"
  },
  "sections": {
    "ongoing": "Käynnissä",
    "upcoming": "Tulevat",
    "past": "Menneet"
  },
  "manager": {
    "weather": {
      "loading": "Haetaan säätietoja…",
      "forecast_loading": "Ladataan ennustetta…",
      "forecast_unavailable": "Ennuste ei saatavilla",
      "error": "Virhe",
      "refresh": "Päivitä sää",
      "updated": "Päivitetty",
      "feels_like": "Tuntuu",
      "wind": "Tuuli m/s",
      "humidity": "Kosteus %",
      "pressure": "Paine hPa",
      "uv_index": "UV-indeksi",
      "rain_probability": "Sadetod. %",
      "station_suffix": "FMI",
      "time_prefix": "klo",
      "days": {
        "su": "Su",
        "ma": "Ma",
        "ti": "Ti",
        "ke": "Ke",
        "to": "To",
        "pe": "Pe",
        "la": "La"
      },
      "days_short": {
        "su": "SU",
        "ma": "MA",
        "ti": "TI",
        "ke": "KE",
        "to": "TO",
        "pe": "PE",
        "la": "LA"
      },
      "compass": {
        "n": "P",
        "ne": "KP",
        "e": "K",
        "se": "KE",
        "s": "E",
        "sw": "LE",
        "w": "L",
        "nw": "LP"
      },
      "conditions": {
        "clear": "Selkeää",
        "mostly_clear": "Melko selkeää",
        "cloudy": "Pilvistä",
        "foggy": "Sumuinen",
        "drizzle": "Tihkusadetta",
        "rain": "Sadetta",
        "snow": "Lumisadetta",
        "rain_showers": "Sadekuuroja",
        "snow_showers": "Lumikuuroja",
        "thunderstorm": "Ukkosta"
      }
    },
    "upcoming_competitions": {
      "title": "Kilpailut",
      "show_more": "Näytä lisää",
      "no_upcoming": "Ei tulevia kilpailuja",
      "prev": "Edelliset kilpailut",
      "next": "Seuraavat kilpailut"
    },
    "members": {
      "title": "Yhteisön jäsenet",
      "invite": "Lisää jäseniä",
      "inviteModal": {
        "title": "Kutsu jäseniä",
        "tabs": {
          "email": "Sähköposti",
          "link": "Liittymislinkki & QR",
          "ebirdie": "eBirdie"
        },
        "joinCode": {
          "description": "Jaa liittymislinkki tai QR-koodi, niin pelaajat voivat liittyä yhteisöön itse.",
          "regenerate": "Luo uusi koodi",
          "codeLabel": "Liittymiskoodi",
          "linkLabel": "Liittymislinkki",
          "copyLink": "Kopioi linkki",
          "copied": "Kopioitu",
          "qrHint": "Pelaaja voi liittyä skannaamalla QR-koodin tai avaamalla linkin.",
          "shareQr": "Jaa QR-koodi",
          "shareTitle": "Yhteisön liittymiskoodi",
          "error": "Liittymiskoodin käsittely epäonnistui."
        },
        "ebirdieNoEmail": "Tälle pelaajalle ei löydy sähköpostiosoitetta, joten häntä ei voi kutsua.",
        "emailsLabel": "Sähköpostiosoitteet",
        "emailPlaceholder": "jasen@example.com",
        "addAddress": "Lisää osoite",
        "removeEmail": "Poista osoite",
        "help": "Lähetämme jokaiselle kutsun sähköpostitse. Osoite, jolla ei vielä ole tiliä, saa rekisteröitymislinkin — jäsenyys aktivoituu, kun kutsu hyväksytään sovelluksessa.",
        "send": "Lähetä kutsut",
        "resultSummary": "Kutsut lähetetty: {{invited}} uutta, {{already}} jo listalla, {{invalid}} virheellistä",
        "errorGeneric": "Kutsujen lähettäminen epäonnistui."
      },
      "columns": {
        "name": "Nimi",
        "email": "Sähköposti",
        "status": "Tila",
        "invited": "Kutsuttu",
        "joined": "Liittynyt"
      },
      "status": {
        "invited": "Kutsuttu – ei tiliä",
        "awaiting": "Odottaa hyväksyntää",
        "active": "Jäsen"
      },
      "empty": "Ei jäseniä",
      "actions": "Toiminnot",
      "select": "Valitse",
      "selectAll": "Valitse kaikki",
      "delete": "Poista jäsenet",
      "deleteConfirm": {
        "header": "Poista jäsenet",
        "body": "Poistetaanko {{count}} jäsentä yhteisöstä? Tätä ei voi perua.",
        "confirm": "Poista"
      },
      "deleteSuccess": "Poistettu {{count}} jäsentä",
      "deleteError": "Jäsenten poistaminen epäonnistui"
    }
  }
}
